<mat-card
  *ngIf="isAnnouncementVisible"
  class="announcement-container"
  [ngClass]="announcement.notificationType">
  <div class="title-container">
    <div class="title">
      <mat-icon
        class="icon-title"
        svgIcon="{{ announcement.notificationType }}"></mat-icon>
      <mat-card-subtitle class="title-text">
        {{ localizationConstants.ANNOUNCEMENT_TITLE | translate }}
      </mat-card-subtitle>
    </div>
    <div>
      <button
        type="button"
        class="button button-action close-button"
        (click)="onCloseButtonClick()"
        [title]="localizationConstants.BUTTON_CLOSE | translate">
        <mat-icon
          class="announcement-close-button"
          svgIcon="close-transparent"></mat-icon>
      </button>
    </div>
  </div>

  <mat-card-content class="content">
    {{ localizationConstants.ANNOUNCEMENT_CONTENT | translate }}
  </mat-card-content>
</mat-card>
